import React from "react";
import { useHistory } from "react-router-dom";
import { CloseCircle } from "app/components/Icon";
import { Routes } from "constants/routes";
import styles from "./styles.module.scss";

const OnboardingNav: React.FC = () => {
  const history = useHistory();

  return (
    <nav className={styles.nav}>
      <CloseCircle
        className={styles.closeButton}
        onClick={() => history.push(Routes.community)}
      />
    </nav>
  );
};

export default OnboardingNav;
